import { CustomMenuItemType } from '../custom-menu-items-type'
import {
  isMenuDividerType,
  isMenuItemType,
  isSubMenuType,
  isGroupMenuType,
} from './custom-menu-item-type-guard'

type ChildType =
  | CustomMenuItemType<'divider'>
  | CustomMenuItemType<'group'>
  | CustomMenuItemType<'submenu'>
  | CustomMenuItemType<'item'>

const searchMenuTreeLvN = (
  children: ChildType[],
  targetKey: string
): string | undefined => {
  let result: string | undefined
  children.forEach((child) => {
    // Check theo level hiện tại

    // Nếu là divider thì skip
    if (isMenuDividerType(child)) return
    // Nếu là item hiện tại thì check
    if (isMenuItemType(child)) {
      if (child.key === targetKey) result = child.key
      return
    }

    // Nếu không phải là item hiện tại và cẫn còn children
    if (isSubMenuType(child) || isGroupMenuType(child)) {
      const value = searchMenuTreeLvN(child.children as ChildType[], targetKey)
      if (value) result = value
    }
  })

  return result
}

/** Tìm parent Key của 1 item trong Antd Menu Items */
const searchMenuTree = (
  parentList: CustomMenuItemType<'dynamic'>['children'],
  targetKey: string
): string | undefined => {
  let result: string | undefined
  parentList.forEach((item) => {
    if (!item) return
    if (item.key === targetKey) {
      result = item.key
      return
    }
    // Tìm trong children
    if (item.children) {
      const value = searchMenuTreeLvN(item.children as ChildType[], targetKey)
      if (value) result = item.key
    }
  })

  return result
}

export default searchMenuTree
